export const SET_DIRTY = (state, payload) => {
  state.dirty = payload;
};

export const SET_INSYNC = (state, payload) => {
  state.inSync = payload;
};

export const SET_UPDATED_AT = (state, payload) => {
  state.current.updatedAt = payload;
};

// export const LOAD_STORAGE = (state, payload) => {
//   state.all = payload.all;
//   state.current = payload.current;
//   console.log(state.current.updatedAt);
// };

/* SECTION ITEMS */
export const CREATE_ITEM = (state, payload) => {
  if (!state.current[payload.section]) {
    return console.error(`${payload.section} does not exist`);
  }
  state.current[payload.section].push(payload.item);
};

export const DELETE_ITEM = (state, payload) => {
  if (!state.current[payload.section]) {
    return console.error(`${payload.section} does not exist`);
  }
  state.current[payload.section].splice(
    state.current[payload.section].indexOf(payload.item),
    1
  );
};

export const SORT_ITEMS = (state, payload) => {
  if (!state.current[payload.section]) {
    return console.error(`${payload.section} does not exist`);
  }
  state.current[payload.section] = payload.items;
};
